import BaseComponent from "../../../../lib/components/BaseComponent";

import DialogBase from "../../../../lib/components/dialogs/DialogBase";
import HCaptcha from "@hcaptcha/react-hcaptcha";
import CM from "../../../model/system/CM";
import {toast} from "react-toastify";
import RequestPasswordResetLink from "../../../../lib/model/service/passwordReset/dto/RequestPasswordResetLink";
import PasswordReset from "../../../../lib/model/service/passwordReset/PasswordReset";
import Button from "../buttons/Button";
import InputText from "../inputFields/InputText";
import T from "../../../model/system/text_translations/Translator";
import VerticalLayout from "../../../../lib/components/layouts/VerticalLayout";
import PropTypes from "prop-types";
import LoadingButton from "@mui/lab/LoadingButton";

class RequestPasswordResetDialog extends BaseComponent {

  constructor(props) {
    super(props);
    this.state = {
      email: null, captchaToken: null, isLoading: false
    }
  }

  onResetPasswordClick(e) {
    this.setState({isLoading: true});
    let dto = new RequestPasswordResetLink(this.state.email, this.state.captchaToken);
    this.doDataFetch(dto, PasswordReset.NAME, (response) => {
      this.setState({isLoading: false});
      if (response.success) {
        toast.success(response.message);
      } else {
        toast.error(response.message);
      }
      this.props.onCloseButtonClick(e);
    });
  }

  render() {
    let theme = CM.get().getTheme() === CM.STD_DARK ? 'dark' : 'light';
    return (<DialogBase
      open={this.props.isOpen}
      ref={this.reference}
      title='Passwort zurücksetzen'
      onCloseButtonClick={(e) => this.props.onCloseButtonClick(e)}
      actions={<>
        <Button
          onClick={(e) => this.props.onCloseButtonClick(e)}
          color=''
          variant='outlined'>
          {T.label_cancel()}
        </Button>
        <LoadingButton
          loading={this.state.isLoading}
          variant='contained'
          onClick={(e) => this.onResetPasswordClick(e)}>
          {'Zurücksetzen'}
        </LoadingButton></>}>
      <VerticalLayout className='gap-4'>
        <InputText
          type={'email'}
          onChange={(e, id, value) => this.state.email = value}
          labelElement='Ihre E-Mailadresse'/>
        <HCaptcha
          theme={theme}
          sitekey={CM.get().getHCaptchaSiteKey()}
          onVerify={(token, eKey) => this.state.captchaToken = token}/>
      </VerticalLayout>
    </DialogBase>);
  }
}

RequestPasswordResetDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired, onCloseButtonClick: PropTypes.func,
}

export default RequestPasswordResetDialog